import { render, staticRenderFns } from "./CustomerLeftSidebar.vue?vue&type=template&id=31bd0d99&scoped=true&"
import script from "./CustomerLeftSidebar.vue?vue&type=script&lang=js&"
export * from "./CustomerLeftSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLeftSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomerLeftSidebar.vue?vue&type=style&index=1&id=31bd0d99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bd0d99",
  null
  
)

export default component.exports